import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const client = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0,
            staleTime: Number.POSITIVE_INFINITY,
        },
    },
});
export function ReactQueryProvider({ children }) {
    return _jsx(QueryClientProvider, { client: client, children: children });
}
